<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="High Function Sports Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first">
            <sub-product tit="High Function Sports Line" file="sports">
                Moisture-repellent/proof, Cooling/Heating function helps consumer lives a healthy life. These functions starts with high-quality yarn and construction of fabric. Discover a variety of silhouettes and fabrications that enrich your life.
            </sub-product>
        </sub-section>

        <!-- <sub-section class="page-section--last">
            <v-img src="/images/sub/product/sports/sports-img.jpg" class="w-100"></v-img>
        </sub-section> -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
